import { render, staticRenderFns } from "./MakeDominionNotif.vue?vue&type=template&id=054729c9&"
import script from "./MakeDominionNotif.vue?vue&type=script&lang=js&"
export * from "./MakeDominionNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports